/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { SlaConfigProviderEntrypointProps } from './SlaConfigProvider.entrypoint.types.tsx';

type SlaConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	SlaConfigProviderEntrypointProps,
	{} | null
>;

export const slaConfigProviderEntrypoint: EntryPoint<SlaConfigProviderEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<SlaConfigProviderEntrypointComponent>(
			/* webpackChunkName: "ai-rovo-actions-sla-provider" */ './SlaConfigProviderEntry.tsx',
		),
		getPreloadProps: () => ({}),
	});
